import button from './components/button';
import headerImage from './components/headerImage';
import style from './components/style';
import footer from './components/footer';
import tinycolor from 'tinycolor2';

module.exports = {
  text: 'Who\'s The Best...',
  value: 'job-opening',
  subject: 'Who\'s the best [Finance Director] you\'ve ever met?',
  mjml(params) {
    const { brandingSettings: branding } = params;
    const slots = params.slots.map(({ content }) => ({
      content: content
        .replace(/{{[\s]*company\.name[\s]*}}/g, '{{defaults company.branding.name company.name "Referrals"}}'),
    }));

    return `<mjml>
      <mj-head>
        <mj-title>${params.subject}</mj-title>
        <mj-include path="../include/styles.mjml"/>
        <mj-attributes>
          <mj-class name="content" background-color="${branding.backgroundColour || '#ffffff'}"/>
        </mj-attributes>
        <mj-style>
          ${style(branding)}
        </mj-style>
      </mj-head>

      <mj-body
        width="760px"
        background-color="${branding.backgroundColour || '#ffffff'}"
      >

        ${!branding.hideBrandLogo ? `<mj-section>
          <mj-column>
            <mj-include path="../include/branding-logo.mjml"/>
          </mj-column>
        </mj-section> ` : ''}

        ${branding.headerImage ? headerImage(branding.headerImage) : ''}

        <mj-section mj-class="content">
          <mj-column>
            <mj-text color="${branding.secondaryColour || '#333333'}">
              <div class="text-content">${slots[0].content}</div>
            </mj-text>
          </mj-column>
        </mj-section>

        <mj-section
          padding="44px 16px"
          background-color="${tinycolor(branding.primaryColour || '#dddddd').lighten(46).toString()}"
        >
          ${slots[1] && slots[1].content ? `<mj-column>${button(slots[1].content, branding)}</mj-column>` : ''}
        </mj-section>

        ${footer(branding)}

        <mj-include path="../include/footer-disclaimer.mjml"/>
      </mj-body>
    </mjml>`;
  },
  slots: [
    {
      name: 'Main Content',
      type: 'html',
      defaultContent: `
        <h1>Who's the best [Finance Director] you've ever met?</h1>
        <h2>We're looking for a new [Finance Director] and we need your help!</h2>
        <p>Cast your mind back and think of the best [finance professional] you've ever worked with. If you
        think we might like to talk to them, login to your Real Links account right now and introduce us</p>
      `,
    },
    {
      name: 'Button Text',
      type: 'input',
      defaultContent: 'Introduce Us!',
    },
  ],
};



// WEBPACK FOOTER //
// ./src/emails/job-opening.js